module.exports = __webpack_public_path__ + "img/default-image.040188ce.jpg";